import { render, staticRenderFns } from "./relatorio-procedimentos.vue?vue&type=template&id=335f2b9d&scoped=true&"
import script from "./relatorio-procedimentos.vue?vue&type=script&lang=js&"
export * from "./relatorio-procedimentos.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-procedimentos.vue?vue&type=style&index=0&id=335f2b9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f2b9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDatePicker,VIcon,VMenu,VRow,VSelect,VSpacer,VSpeedDial,VTextField})
